import React from 'react';
import styled from 'styled-components';

const TranslateContainer = styled.div`
  display: inline-block;
  
  #google_translate_element {
    display: inline-block;
  }
  
  .goog-te-combo {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 20px;
    color: white;
    padding: 0.25rem 0.5rem;
    font-size: 0.9rem;
    cursor: pointer;
    outline: none;
    
    &:hover {
      background: rgba(255, 255, 255, 0.15);
    }
    
    option {
      background: #1a1a1a;
      color: white;
    }
  }
  
  .goog-te-gadget {
    font-family: inherit;
    font-size: inherit;
  }
  
  .goog-te-gadget-simple {
    background: transparent !important;
    border: none !important;
    padding: 0 !important;
  }
  
  .goog-te-gadget-icon {
    display: none !important;
  }
  
  .goog-te-menu-value {
    color: white !important;
  }
  
  .goog-te-menu-value span {
    color: white !important;
  }
`;

export const GoogleTranslate: React.FC = () => {
  return (
    <TranslateContainer>
      <div id="google_translate_element"></div>
    </TranslateContainer>
  );
};
